/**
 * Uvod lijevog panela prijave (ms od otvaranja stranice): prvo se iscrta cesta, zatim se
 * u sredini pojavi uvećan logo, on odlazi u gornji lijevi kut, a na njegovo mjesto ulazi
 * scena prijave.
 */
export const LOGIN_INTRO_TIMING = {
  /** Cesta se crta ~1,5 s (tri trake s pomakom), logo ulazi dok se dovršava. */
  logo: 1200,
  /** Cesta (nacrtana do ~2,1 s) i logo neko vrijeme stoje mirno, pa odlaze zajedno. */
  dock: 5000,
  /**
   * Scena ulazi tek kad je cesta potpuno otišla (najsporija traka izlazi do ~6,6 s),
   * pa se forma i cesta ne preklapaju.
   */
  scene: 6800,
};

/**
 * Logo stoji u kutu (top-8 left-8), a uvod ga transformom pomakne u sredinu panela
 * (pola ekrana širok, cijeli visok) i uveća. Animira se samo transform — pomicanje
 * top/left preračunava raspored u svakom kadru i trza.
 */
export const LOGIN_INTRO_LOGO_CENTERED = "translate(calc(25vw - 2rem - 50%), calc(50vh - 2rem - 50%)) scale(1.75)";
export const LOGIN_INTRO_LOGO_DOCKED = "translate(0, 0) scale(1)";
